import { createTheme } from '@mui/material/styles';
export const createMuiThemeFromStyled = (styledTheme) => createTheme({
    palette: {
        mode: styledTheme.mode,
        primary: { main: styledTheme.colors.primary },
        text: { primary: styledTheme.colors.text },
        background: {
            default: styledTheme.colors.background,
            paper: styledTheme.colors.background,
        },
    },
    typography: {
        fontFamily: 'Montserrat, sans-serif',
    },
});
